;(function () {
  'use strict'

  angular.module('contrast.login').directive('csLoginLogo', [csLoginLogo])

  function csLoginLogo() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'views/cs-login-logo.html'
    }
  }
})()
